import React, { useState } from "react";
import api from "api";
import { Route } from "react-router-dom";
import { LoaderWithScreen, default as Loader } from "Loader";
import { serverType, serverTypes } from "enums";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import LootTable from "loot/lootTable";
import Modal from "components/Modal";

function ServerList({ servers, refreshData }) {
  const [assigningPlayer, setAssigningPlayer] = useState({});
  const close = () => setAssigningPlayer({});
  return (
    <>
      <Modal fade={false} isOpen={assigningPlayer.Guid} toggle={close}>
        <ModalHeader toggle={close}>Move {assigningPlayer.Name}</ModalHeader>
        <ModalBody>
          <h3>Server Type</h3>
          {serverTypes.map((type) => (
            <Button
              onClick={async () => {
                close();
                await api.server.transitionType(assigningPlayer.Guid, type);
                refreshData(false, false);
              }}
            >
              {serverType(type)}
            </Button>
          ))}
          <h3>Matches</h3>
          {servers.map((server) => (
            <Button
              onClick={async () => {
                close();
                await api.server.transitionMatch(assigningPlayer.Guid, server.MatchId);
                refreshData(false, false);
              }}
            >
              {serverType(server.ServerType) + ": " + server.MatchId}
            </Button>
          ))}
        </ModalBody>
      </Modal>
      {servers.map((server) => (
        <div>
          {serverType(server.ServerType) + ": " + server.MatchId}&nbsp;
          <a href={"/match/" + server.MatchId}>Watch</a>&nbsp;
          <a href={"/profile/" + server.IP + ":" + server.AdminPort}>Profile</a>&nbsp;
          <Button
            color="danger"
            onClick={async () => {
              await api.server.removeserver(server.MatchId);
              refreshData(false, false);
            }}
          >
            Remove
          </Button>
          <ul>
            {server.DbPlayers.map((p) => (
              <li key={p.Guid}>
                {p.Name}&nbsp;
                <Button className="stealth" onClick={() => setAssigningPlayer(p)}>
                  Move
                </Button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}

function PlayPrivilegeDropDown({ playPrivilege, refreshData }) {
  const pName = (p) => ["None", "Playtest", "Cheats", "Playtest+Cheats", "Admin"][p];
  function Item({ priv }) {
    return (
      <DropdownItem
        onClick={async () => {
          await api.server.setPlayPrivilege(priv);
          refreshData(false, false);
        }}
      >
        {pName(priv)}
      </DropdownItem>
    );
  }
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret size="md">
        {pName(playPrivilege)}
      </DropdownToggle>
      <DropdownMenu>
        <Item priv={0} />
        <Item priv={1} />
        <Item priv={2} />
        <Item priv={4} />
      </DropdownMenu>
    </Dropdown>
  );
}

export class AdminRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = { configData: {} };
  }
  render() {
    return (
      <Route exact path="/admin">
        <Loader dataSource={() => api.server.refresh()}>
          {({ loading, data, error, refreshData }) => {
            return (
              <>
                <h2>
                  Servers <Button onClick={() => refreshData(null, false)}>⟳</Button>
                </h2>
                <div className="row">
                  {(!loading &&
                    ((data && <ServerList servers={data} refreshData={refreshData} />) ||
                      error.Message)) ||
                    "Loading"}
                </div>
              </>
            );
          }}
        </Loader>
        <h2>Config</h2>
        <LoaderWithScreen dataSource={() => api.server.getConfig()}>
          {({ data, error, refreshData }) => {
            if (error) return error.Message;
            if (!data) return "Empty config response.";
            return (
              <>
                <div className="row">
                  <div className="col">Config: {JSON.stringify(data.Config)}</div>
                </div>
                <div className="row">
                  <div className="col">Config Key</div>
                  <input
                    className="col"
                    type="text"
                    value={this.state.configKey}
                    onChange={(e) => this.setState({ configKey: e.target.value })}
                    name="name"
                  />
                  <Button
                    className="col"
                    onClick={async () => {
                      await api.server.deleteConfig(this.state.configKey);
                      refreshData(false, false);
                    }}
                  >
                    Delete
                  </Button>
                </div>
                <div className="row">
                  <div className="col">Config Value</div>
                  <input
                    className="col"
                    type="text"
                    value={this.state.configValue}
                    onChange={(e) => this.setState({ configValue: e.target.value })}
                    name="name"
                  />
                  <Button
                    className="col"
                    onClick={async () => {
                      let value = this.state.configValue;
                      try {
                        value = JSON.parse(value);
                      } catch (e) {}
                      await api.server.setConfig(this.state.configKey, value);
                      refreshData(false, false);
                    }}
                  >
                    Set
                  </Button>
                </div>
                <div className="row">
                  <div className="col">Set now offset (hours)</div>
                  <input
                    className="col"
                    type="text"
                    value={this.state.nowOffset}
                    onChange={(e) => this.setState({ nowOffset: e.target.value })}
                    name="name"
                  />
                  <Button
                    className="col"
                    onClick={() =>
                      api.server.setNowOffset(Number.parseInt(this.state.nowOffset * 3600))
                    }
                  >
                    Send
                  </Button>
                </div>
                <h2>Control</h2>
                Server Config: {JSON.stringify(data.ServerConfig)}
                <div className="row">
                  <div className="col">Send notification</div>
                  <input
                    className="col"
                    type="text"
                    value={this.state.notification}
                    onChange={(e) => this.setState({ notification: e.target.value })}
                    name="name"
                  />
                  <Button
                    className="col"
                    onClick={() => api.server.notify(this.state.notification)}
                  >
                    Send
                  </Button>
                </div>
                <div className="row">
                  <div className="col">Set warm pool size</div>
                  <input
                    className="col"
                    type="text"
                    value={this.state.warmPool}
                    onChange={(e) => this.setState({ warmPool: e.target.value })}
                    name="name"
                  />
                  <Button
                    className="col"
                    onClick={() => api.server.setwarmpool(Number.parseInt(this.state.warmPool))}
                  >
                    Send
                  </Button>
                </div>
                <div className="col">Play Privilege:</div>
                <PlayPrivilegeDropDown
                  playPrivilege={data.PlayPrivilege}
                  refreshData={refreshData}
                />
                <h2>Info</h2>
                Idle Duration: {data.IdleDuration}
              </>
            );
          }}
        </LoaderWithScreen>
        <LootTable />
      </Route>
    );
  }
}
